<template>
  <div class="app-container">
    
    <!-- 主体内容 - 使用 router-view 显示当前路由组件 -->
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <!-- 底部导航栏 -->
    <van-tabbar v-model="active" :style="{ borderTop: '1px solid #f7f8fa' }">
      <van-tabbar-item
        v-for="(item, index) in tabbarItems"
        :key="index"
        :name="item.name"
        :icon="item.icon"
        @click="channel(item.name)"
        :style="{ color: active === item.name ? themeColor : '' }"
      >
        {{ item.text }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { get } from '@/api';
import { TokenService } from '@/utils/auth';
import {
  Tabbar as VanTabbar,
  TabbarItem as VanTabbarItem
} from 'vant';

const themeColor = '#FF5A5F';
const route = useRoute();

// 根据当前路由设置 active
const active = computed(() => {
  const routeName = route.name;
  return tabbarItems.find(item => item.name === routeName.toLowerCase())?.name || 'home';
});

const channel = (name) => {
  if (name == 'home') {
    window.location.href = '/';
  } else {
    window.location.href = '/' + name;
  }
  
}

const tabbarItems = [
  {
    name: 'order',
    text: '订单',
    icon: 'orders-o',
    to: '/order'
  },
  {
    name: 'goods',
    text: '产品',
    icon: 'shopping-cart-o',
    to: '/goods'
  },
  {
    name: 'operation',
    text: '统计',
    icon: 'chart-trending-o',
    to: '/operation'
  },
  {
    name: 'home',
    text: '总览',
    icon: 'balance-list-o',
    to: '/'
  }
];

const getShopName = async () => {
  const token = TokenService.getToken();

  if (token && route.name != 'empty' && route.name != 'loginexpire') {
    try {
      const data = await get('/shop/get-shop-name');
      document.title = data.shop_name;
    } catch (error) {
      console.error('获取店铺名称失败:', error);
    }
  }
};

onMounted(() => {
  if (route.name != 'empty' && route.name != 'loginexpire') {
    getShopName();
  }
});
</script>

<style>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: white;
}

.main-content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empty-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  color: #969799;
  font-size: 14px;
}

/* vant 组件样式覆盖 */
:root {
  --van-primary-color: #FF5A5F;
  --van-nav-bar-title-text-color: white;
  --van-nav-bar-height: 46px;
}

.van-nav-bar {
  background-color: #FF5A5F;
}

.van-nav-bar__title {
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.van-tabbar-item--active {
  color: #FF5A5F;
}

.van-tabbar-item__icon .van-icon {
  font-size: 20px;
}

/* 添加页面切换动画 */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
</style>